import { jwtDecode } from "jwt-decode"

export const isTokenValid = ( userToken ) => {
    if(!userToken) return false;

    try {
        const decoded = jwtDecode(userToken);

        return decoded.exp * 1000 > Date.now();
    } catch {
        return false;
    }
};